// UNIFIED MENU SYSTEM - BURGER TOGGLE
document.addEventListener("DOMContentLoaded", function () {
  // Fonction pour trouver l'iframe
  function findIframe() {
    // D'abord essayer avec l'ID
    let iframe = document.getElementById("myUALContactIframe");

    // Si pas trouvé, chercher par domaine
    if (!iframe) {
      const iframes = document.querySelectorAll("iframe");
      for (let i = 0; i < iframes.length; i++) {
        if (
          iframes[i].src &&
          iframes[i].src.includes("https://formulaire.atpartner.fr")
        ) {
          iframe = iframes[i];
          break;
        }
      }
    }

    return iframe;
  }

  window.addEventListener("message", (event) => {
    // Vérifie que le message vient bien du domaine attendu
    const allowedOrigin = "https://formulaire.atpartner.fr";

    if (event.origin !== allowedOrigin) {
      console.warn("Message reçu d'une origine non autorisée :", event.origin);
      return; // Ignore les messages d'autres origines
    }

    // Chercher l'iframe à chaque message
    const iframe = findIframe();

    if (!iframe) {
      console.warn("Iframe non trouvée pour le message reçu");
      return;
    }

    if (event.data.iframeHeight) {
      iframe.style.height = event.data.iframeHeight + "px";
    }
  });

  const burger = document.querySelector(".menu-burger");
  const navWrapper = document.querySelector(".nav-wrapper");
  const mobileSearchToggle = document.querySelector(".mobile-search-toggle");
  const mobileSearchBar = document.querySelector(".mobile-search-bar");

  // Burger menu toggle
  if (burger && navWrapper) {
    burger.addEventListener("click", function () {
      this.classList.toggle("active");
      navWrapper.classList.toggle("open");

      // Toggle body scroll lock on mobile
      const isOpen = navWrapper.classList.contains("open");
      if (window.innerWidth < 1024) {
        document.body.classList.toggle("mobile-menu-open", isOpen);
      }

      // Close search bar when opening menu
      if (isOpen && mobileSearchBar) {
        mobileSearchBar.classList.remove("active");
      }

      // Update aria-expanded
      this.setAttribute("aria-expanded", isOpen);
    });

    // Close menu when clicking on a direct link (not mega-menu trigger)
    const directLinks = navWrapper.querySelectorAll(
      ".menu-link:not([data-mega-menu-trigger])",
    );
    directLinks.forEach((link) => {
      link.addEventListener("click", () => {
        burger.classList.remove("active");
        navWrapper.classList.remove("open");
        burger.setAttribute("aria-expanded", "false");

        // Unlock body scroll
        if (window.innerWidth < 1024) {
          document.body.classList.remove("mobile-menu-open");
        }
      });
    });
  }

  // Mobile search toggle
  if (mobileSearchToggle && mobileSearchBar) {
    mobileSearchToggle.addEventListener("click", function () {
      mobileSearchBar.classList.toggle("active");

      // Close menu when opening search
      if (mobileSearchBar.classList.contains("active") && navWrapper) {
        burger.classList.remove("active");
        navWrapper.classList.remove("open");
        burger.setAttribute("aria-expanded", "false");
      }
    });
  }

  // MEGA MENU TRIGGERS
  const megaMenuTriggers = document.querySelectorAll(
    "[data-mega-menu-trigger]",
  );

  megaMenuTriggers.forEach((trigger) => {
    const menuItem = trigger.closest(".menu-item");
    const megaMenuId = trigger.getAttribute("data-mega-menu-trigger");
    const megaMenu = document.getElementById(`mega-menu-${megaMenuId}`);

    if (!menuItem || !megaMenu) return;

    // SUPPRIMÉ: Desktop hover behavior - on garde uniquement le clic
    // Mobile & Desktop: click behavior ONLY
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = menuItem.classList.contains("open");

      // Close all other mega menus (DESKTOP ONLY)
      if (window.innerWidth >= 1024) {
        document
          .querySelectorAll(".menu-item.has-mega-menu.open")
          .forEach((item) => {
            if (item !== menuItem) {
              item.classList.remove("open");
              item
                .querySelector("[data-mega-menu-trigger]")
                .setAttribute("aria-expanded", "false");
            }
          });
      }

      // Toggle current menu
      menuItem.classList.toggle("open");
      trigger.setAttribute("aria-expanded", !isOpen);
    });

    // Close mega menu when clicking on a link inside (mobile only)
    if (window.innerWidth < 1024) {
      const megaMenuLinks = megaMenu.querySelectorAll("a");
      megaMenuLinks.forEach((link) => {
        link.addEventListener("click", () => {
          menuItem.classList.remove("open");
          trigger.setAttribute("aria-expanded", "false");

          // Also close the main mobile menu
          if (burger && navWrapper) {
            burger.classList.remove("active");
            navWrapper.classList.remove("open");
            burger.setAttribute("aria-expanded", "false");
            document.body.classList.remove("mobile-menu-open");
          }
        });
      });
    }
  });

  // Close mega menus when clicking outside
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".menu-item.has-mega-menu")) {
      document
        .querySelectorAll(".menu-item.has-mega-menu.open")
        .forEach((item) => {
          item.classList.remove("open");
          item
            .querySelector("[data-mega-menu-trigger]")
            .setAttribute("aria-expanded", "false");
        });
    }
  });

  // Close mega menus with Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      document
        .querySelectorAll(".menu-item.has-mega-menu.open")
        .forEach((item) => {
          item.classList.remove("open");
          item
            .querySelector("[data-mega-menu-trigger]")
            .setAttribute("aria-expanded", "false");
        });
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  // Footer columns accordion (for mobile)
  const footerColumns = document.querySelectorAll(
    ".footer-column.menu-item-has-children h4",
  );
  footerColumns.forEach((title) => {
    title.addEventListener("click", (e) => {
      if (window.innerWidth < 1024) {
        const parentColumn = title.closest(".footer-column");
        const subMenu = parentColumn.querySelector(".sub-menu");
        const svg = title.querySelector("svg");

        // Toggle
        parentColumn.classList.toggle("open");
        subMenu.classList.toggle("max-lg:hidden");
        if (svg) {
          svg.style.transform = parentColumn.classList.contains("open")
            ? "rotate(180deg)"
            : "rotate(0deg)";
        }
      }
    });
  });
});

// Gammes accordion mobile (<1024px)
document.addEventListener("DOMContentLoaded", function () {
  function isMobile() {
    return window.innerWidth < 1024;
  }
  const gammeCards = document.querySelectorAll(".gamme-card");
  gammeCards.forEach((card) => {
    const title = card.querySelector(".gamme-title");
    if (title) {
      title.addEventListener("click", function (e) {
        if (!isMobile()) return;
        e.preventDefault();
        // Fermer toutes les autres cartes
        gammeCards.forEach((otherCard) => {
          if (otherCard !== card) {
            otherCard.classList.remove("is-open");
          }
        });
        // Toggle la carte cliquée
        card.classList.toggle("is-open");
      });
    }
  });
  // Optionnel : refermer la carte ouverte si on clique en dehors
  document.addEventListener("click", function (e) {
    if (!isMobile()) return;
    const openCard = document.querySelector(".gamme-card.is-open");
    if (openCard && !openCard.contains(e.target)) {
      openCard.classList.remove("is-open");
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  console.log("Search script loaded");

  // Sélectionner tous les conteneurs de recherche
  const searchContainers = document.querySelectorAll(
    ".search-container, .search-container-frontpage",
  );
  console.log("Found search containers:", searchContainers.length);

  searchContainers.forEach((container, index) => {
    console.log("Processing container", index);

    const searchInput = container.querySelector(".search-input");
    const searchToggle = container.querySelector(".search-toggle");
    const closeIcon = container.querySelector(".close-icon");
    let isOpen = false;

    console.log("Elements found:", {
      input: !!searchInput,
      toggle: !!searchToggle,
      close: !!closeIcon,
    });

    if (!searchInput || !searchToggle || !closeIcon) {
      console.log("Missing elements in container", index);
      return;
    }

    // Fonction pour ouvrir la recherche
    function openSearch() {
      console.log("Opening search");
      isOpen = true;
      searchInput.classList.add("open");
      searchToggle.classList.add("open");
      closeIcon.classList.add("open");
      searchToggle.setAttribute("aria-label", "Fermer la recherche");

      // Focus sur l'input après l'animation
      setTimeout(() => {
        searchInput.focus();
      }, 100);
    }

    // Fonction pour fermer la recherche
    function closeSearch() {
      console.log("Closing search");
      isOpen = false;
      searchInput.classList.remove("open");
      searchToggle.classList.remove("open");
      closeIcon.classList.remove("open");
      searchToggle.setAttribute("aria-label", "Ouvrir la recherche");
      searchInput.value = ""; // Optionnel: vider le champ
    }

    // Event listener pour le bouton de recherche
    searchToggle.addEventListener("click", function (e) {
      console.log("Search toggle clicked");
      e.preventDefault();
      e.stopPropagation();

      if (!isOpen) {
        openSearch();
      } else {
        closeSearch();
      }
    });

    // Event listener pour le bouton de fermeture
    closeIcon.addEventListener("click", function (e) {
      console.log("Close icon clicked");
      e.preventDefault();
      e.stopPropagation();
      closeSearch();
    });

    // Fermer avec la touche Escape
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen) {
        closeSearch();
      }
    });

    // Fermer quand on clique à l'extérieur
    document.addEventListener("click", function (e) {
      if (isOpen && !container.contains(e.target)) {
        closeSearch();
      }
    });

    // Empêcher la fermeture quand on clique dans l'input
    searchInput.addEventListener("click", function (e) {
      e.stopPropagation();
    });

    // Support clavier pour le bouton
    searchToggle.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        console.log("Keyboard activation");
        e.preventDefault();
        if (!isOpen) {
          openSearch();
        } else {
          closeSearch();
        }
      }
    });
  });
});

(($) => {
  $(document).ready(function () {
    // LIGHTGALLERY - Wrap Gutenberg gallery images in links
    $(".wp-block-gallery.lightgallery").each(function () {
      const $gallery = $(this);

      // Find all images in the gallery
      $gallery.find(".wp-block-image img").each(function () {
        const $img = $(this);
        const $parent = $img.parent();

        // Skip if already wrapped in a link
        if ($parent.is("a")) {
          return;
        }

        // Get original image URL for lightgallery popup
        let fullImageUrl = $img.attr("src");
        const srcset = $img.attr("srcset");

        if (srcset) {
          // Trier le srcset par largeur (descendant) pour prendre la plus grande taille générée
          const srcsetEntries = srcset.split(",").map((entry) => {
            const parts = entry.trim().split(/\s+/);
            return { url: parts[0], width: parseInt(parts[1]) || 0 };
          });
          srcsetEntries.sort((a, b) => b.width - a.width);
          if (srcsetEntries.length > 0) {
            fullImageUrl = srcsetEntries[0].url;
          }
        }

        // WordPress génère une version -scaled (2560px max) pour les grandes images.
        // Supprimer le suffixe -scaled donne l'URL de l'image originale non réduite.
        fullImageUrl = fullImageUrl.replace(/-scaled(\.[a-z]+)$/i, "$1");

        // Get alt text for caption
        const altText = $img.attr("alt") || "";

        // Create wrapper link
        const $link = $("<a>", {
          href: fullImageUrl,
          "data-src": fullImageUrl,
          "data-sub-html": altText ? `<h4>${altText}</h4>` : "",
        });

        // Remove problematic attributes
        $img.removeAttr("width").removeAttr("height").removeAttr("sizes");

        // Force styles with inline CSS (higher specificity than external CSS)
        $img.css({
          "max-width": "365px !important",
          "max-height": "191px !important",
          width: "100%",
          height: "100%",
          "object-fit": "cover",
          "border-radius": "2px",
        });

        // Wrap the image/picture element
        if ($img.parent("picture").length) {
          const $picture = $img.parent("picture");

          // Style the picture element
          $picture.css({
            display: "block",
            "max-width": "365px",
            "max-height": "191px",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            "border-radius": "2px",
          });

          $picture.wrap($link);
        } else {
          $img.wrap($link);
        }
      });

      // Style the figure containers after wrapping
      $gallery.find(".wp-block-image").css({
        "max-width": "365px",
        "max-height": "191px",
        overflow: "hidden",
      });
    });

    // Initialize LightGallery on all galleries
    $(".lightgallery")
      .lightGallery({
        download: false,
        selector: "a",
        counter: true,
        thumbnail: true,
        animateThumb: true,
        showThumbByDefault: false,
      })
      .on("onBeforeSlide.lg", function () {
        $(".lg-backdrop").css("opacity", "0.8");
        $(".lg-sub-html").css("opacity", "0");
      });
  });

  // const accordions = $(".wp-block-data-theme-accordion");

  // accordions.each(function () {
  //   const label = $(this).find(".accordion--label");
  //   const content = $(this).find(".accordion--content");

  //   label.on("click", function () {
  //     $(this).toggleClass("active");
  //     content.slideToggle(300).toggleClass("hidden active");
  //     $(this).closest(".wp-block-data-theme-accordion").toggleClass("active");
  //   });
  // });

  // const glide = new Glide(".glide", {
  //   type: "carousel",
  //   perView: 3.02,
  //   touchAngle: 0,
  //   breakpoints: {
  //     1103: {
  //       touchAngle: 45,
  //       autoplay: 4000,
  //       perView: 2.02,
  //       focusAt: "center",
  //     },
  //     506: {
  //       touchAngle: 45,
  //       autoplay: 4000,
  //       perView: 1.03,
  //       focusAt: "center",
  //       peek: {
  //         before: 20,
  //         after: 20,
  //       },
  //     },
  //   },
  // });

  // glide.mount();
})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
  // =============================================================================
  // ADD TO FAVORITES BUTTON
  // =============================================================================

  const addToFavBtns = document.querySelectorAll(".add-to-favorites");

  function setFavoritedState(btn) {
    btn.disabled = true;
    btn.innerHTML = `
      <span class="text-sm lg:text-base font-bold">\u2713 Ajout\u00e9 aux favoris</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="22" viewBox="0 0 26 22" fill="currentColor" class="transition-all">
        <path d="M11.0768 2.59541L12.5147 4.09376L13.9526 2.59518C15.0836 1.41635 16.6469 0.75 18.2806 0.75H18.4561C21.6721 0.75 24.2794 3.35729 24.2792 6.57329C24.2792 8.11776 23.6658 9.5987 22.5738 10.6907L12.5147 20.75L2.45565 10.6909C1.36341 9.5987 0.75 8.11776 0.75 6.57329C0.75 3.35706 3.35706 0.75 6.57329 0.75H6.74859C8.38247 0.75 9.94576 1.41635 11.0768 2.59541Z" fill="currentColor"/>
      </svg>
    `;
    btn.classList.add(
      "opacity-70",
      "cursor-default",
      "!cursor-default",
      "pointer-events-none",
    );
  }

  // Initialise l'état des boutons déjà en favori (via data-is-favorited depuis PHP)
  addToFavBtns.forEach((btn) => {
    if (btn.dataset.isFavorited === "true") {
      setFavoritedState(btn);
    }
  });

  addToFavBtns.forEach((addToFavBtn) => {
    const productId = addToFavBtn.dataset.productId;
    const colorisId = addToFavBtn.dataset.colorisId;
    const postId = addToFavBtn.dataset.postId;

    if (productId || colorisId || postId) {
      addToFavBtn.addEventListener("click", function (e) {
        e.preventDefault();

        // Check if user is logged in
        if (!ajax.user_logged_in) {
          alert(
            "Vous devez être connecté pour ajouter des éléments aux favoris.",
          );
          window.location.href = "/mon-mon-espace-projet/";
          return;
        }

        // Disable button during request
        addToFavBtn.disabled = true;
        const originalText = addToFavBtn.innerHTML;
        addToFavBtn.innerHTML =
          '<span class="animate-pulse">Ajout en cours...</span>';

        const formData = new FormData();
        formData.append("action", "add_to_favorites");

        if (productId) formData.append("product_id", productId);
        if (colorisId) formData.append("coloris_id", colorisId);
        if (postId) formData.append("post_id", postId);

        fetch(ajax.url, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              setFavoritedState(addToFavBtn);
              // Optional: Show toast notification
              showToast(data.data.message || "Ajout\u00e9 aux favoris !");
            } else {
              alert(data.data.message || "Une erreur est survenue.");
              addToFavBtn.disabled = false;
              addToFavBtn.innerHTML = originalText;
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            alert("Une erreur réseau est survenue.");
            addToFavBtn.disabled = false;
            addToFavBtn.innerHTML = originalText;
          });
      });
    }
  });

  // =============================================================================
  // SHARE BUTTON
  // =============================================================================

  const shareBtn = document.querySelector(".article-header__share-btn");

  if (shareBtn) {
    shareBtn.addEventListener("click", function () {
      const url = window.location.href;
      const title = shareBtn.dataset.shareTitle || document.title;

      if (navigator.share) {
        navigator.share({ title, url }).catch(function () {
          // Partage annulé par l'utilisateur – pas d'erreur à afficher
        });
      } else {
        navigator.clipboard
          .writeText(url)
          .then(function () {
            showToast("Lien copié dans le presse-papier !");
          })
          .catch(function () {
            // Fallback si clipboard API indisponible
            const input = document.createElement("input");
            input.value = url;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);
            showToast("Lien copié dans le presse-papier !");
          });
      }
    });
  }

  function showToast(message) {
    const toast = document.createElement("div");
    toast.className =
      "fixed bottom-4 right-4 bg-primary text-white px-6 py-3 rounded-[2px] shadow-lg z-50 animate-fade-in";
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(() => {
      toast.classList.add("animate-fade-out");
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 300);
    }, 3000);
  }
});
/**
 * FAQ Accordion functionality
 * Handles the opening/closing of FAQ items with smooth animations
 */

jQuery(document).ready(function ($) {
  // Use event delegation so dynamically added blocks work too
  $(document).on("click", ".dropdown-question-wrapper", function () {
    const $button = $(this);

    // Scope to the closest dropdown item to support multiple FAQ blocks on the page
    const $dropdownItem = $button.closest(".dropdown-item");

    // Prefer a relative .dropdown-answer inside the same item (avoids ID collisions)
    let $dropdownAnswer = $dropdownItem.find(".dropdown-answer").first();

    // Fallback: if aria-controls id is present and unique, use it
    if (!$dropdownAnswer.length) {
      const answerId = $button.attr("aria-controls");
      if (answerId) {
        $dropdownAnswer = $("#" + answerId);
      }
    }

    const $arrowIcon = $button.find(".faq-arrow-icon");
    const $arrowSvg = $arrowIcon.find("svg");

    if (!$dropdownAnswer.length) return; // nothing to toggle

    // Toggle active class
    const isActive = $dropdownItem.hasClass("active");

    if (isActive) {
      // Close
      $dropdownItem.removeClass("active");
      $arrowSvg.css("transform", "rotate(0deg)");

      const currentHeight = $dropdownAnswer.height();
      $dropdownAnswer.css("height", currentHeight + "px");

      // Force reflow
      $dropdownAnswer[0].offsetHeight;

      $dropdownAnswer.css("height", "0");

      setTimeout(() => {
        $dropdownAnswer.removeClass("active");
        $dropdownAnswer.css("height", "");
      }, 300);
    } else {
      // Open
      $dropdownItem.addClass("active");
      $arrowSvg.css("transform", "rotate(180deg)");

      $dropdownAnswer.addClass("active");
      $dropdownAnswer.css("height", "0");

      const content = $dropdownAnswer.find(".dropdown-answer-content");
      const targetHeight =
        content.outerHeight(true) || $dropdownAnswer.prop("scrollHeight");

      // Force reflow
      $dropdownAnswer[0].offsetHeight;

      $dropdownAnswer.css("height", targetHeight + "px");

      // Remove fixed height after the transition to allow flexible content
      setTimeout(() => {
        $dropdownAnswer.css("height", "auto");
      }, 300);
    }
  });
});
